import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '@nrwl/common-lib';
import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';

@Component({
  selector: 'update-user-password',
  templateUrl: 'update.user.password.template.html',
  styleUrls: ['./update.user.password.style.scss']
})
export class UpdateUserPasswordComponent implements OnInit, IWizardContentComponent {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm') currentForm: NgForm;

  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
  canManageUsers: boolean;
  passwordValidationOptions = {
    minUpperCaseChar: 1,
    minLowerCaseChar: 1,
    minSpecialChar: 1,
    minDigits: 1
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private readonly userService: UserService) {}

  ngOnInit() {
    this.canManageUsers = this.wizardCtrl.getWizardService().canManagePermissions() && 
                          this.userService.getUserName() !== this.wizardCtrl.getWizardService()?.defaultParamsById?.username;
    this.step.form = this.currentForm;
    if (!this.userService.isActiveTestProject()) {
      this.passwordValidationOptions.minUpperCaseChar = 0;
      this.passwordValidationOptions.minLowerCaseChar = 0;
      this.passwordValidationOptions.minSpecialChar = 0;
      this.passwordValidationOptions.minDigits = 0;
    }
  }

  currentPasswordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'oldPwdInput',
      key: 'oldPassword',
      newValue: this.currentPassword,
      isValid: this.currentForm.controls.oldPassword.valid
    });
  }

  newPasswordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'newPwdInput',
      key: 'newPassword',
      newValue: this.newPassword,
      isValid: this.currentForm.controls.newPassword.valid
    });
    this.confirmPasswordUpdated();
  }

  confirmPasswordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'newPwdRepeatInput',
      key: 'newPasswordRepeat',
      newValue: this.newPasswordRepeat,
      isValid: this.currentForm.controls.newPasswordRepeat.valid
    });
  }

  isLoading(): boolean {
    return this.wizardCtrl.getWizardService().isLoading;
  }
}
